interface LoadingModalProps {
  isOpen: boolean
  message: string
}

function LoadingModal({ isOpen, message }: LoadingModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Non-dismissible backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Dialog */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-sm w-full mx-4 p-8">
        <div className="flex flex-col items-center gap-4">
          {/* Spinner */}
          <div className="w-12 h-12 border-4 border-gray-200 border-t-fx-buy rounded-full animate-spin"></div>

          {/* Message */}
          <p className="text-center text-gray-700 font-medium">{message}</p>
        </div>
      </div>
    </div>
  )
}

export default LoadingModal
